import { Box, Icon, IconProps } from '@chakra-ui/react'

export const DashboardIcon = (props: IconProps) => (
  <Icon viewBox='0 0 20 20' {...props}>
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.6' y='0.6' width='7.79991' height='7.79991' rx='2.4' stroke='currentColor' strokeWidth='1.2' />
      <rect x='11.6' y='0.6' width='7.79991' height='7.79991' rx='2.4' stroke='currentColor' strokeWidth='1.2' />
      <rect x='0.6' y='11.5998' width='7.79991' height='7.79991' rx='2.4' stroke='currentColor' strokeWidth='1.2' />
      <rect x='11.6' y='11.5998' width='7.79991' height='7.79991' rx='2.4' stroke='currentColor' strokeWidth='1.2' />
    </svg>
  </Icon>
)

export const PlaylistIcon = (props: IconProps) => (
  <Icon viewBox='0 0 22 22' {...props}>
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21 11C21 5.47917 16.5208 1 11 1C5.47917 1 1 5.47917 1 11C1 16.5208 5.47917 21 11 21C16.5208 21 21 16.5208 21 11Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
      />
      <path
        d='M15.931 5.52837L9.82684 7.97004C9.40761 8.13769 9.02681 8.38877 8.70755 8.70804C8.38828 9.0273 8.13721 9.4081 7.96955 9.82733L5.52788 15.9315C5.49758 16.0072 5.49016 16.0902 5.50655 16.1701C5.52294 16.25 5.56241 16.3233 5.62009 16.381C5.67776 16.4386 5.75109 16.4781 5.83098 16.4945C5.91088 16.5109 5.99383 16.5035 6.06955 16.4732L12.1737 14.0315C12.5929 13.8638 12.9737 13.6128 13.293 13.2935C13.6123 12.9742 13.8634 12.5934 14.031 12.1742L16.4727 6.07004C16.503 5.99432 16.5104 5.91137 16.494 5.83147C16.4776 5.75158 16.4381 5.67825 16.3805 5.62057C16.3228 5.5629 16.2495 5.52342 16.1696 5.50703C16.0897 5.49065 16.0067 5.49806 15.931 5.52837V5.52837ZM11.0003 12.2508C10.7531 12.2508 10.5114 12.1775 10.3058 12.0401C10.1003 11.9028 9.94004 11.7075 9.84543 11.4791C9.75082 11.2507 9.72607 10.9994 9.7743 10.7569C9.82253 10.5144 9.94158 10.2917 10.1164 10.1169C10.2912 9.94207 10.5139 9.82302 10.7564 9.77479C10.9989 9.72655 11.2502 9.75131 11.4786 9.84592C11.707 9.94053 11.9023 10.1007 12.0396 10.3063C12.177 10.5119 12.2503 10.7535 12.2503 11.0008C12.2503 11.3323 12.1186 11.6502 11.8842 11.8846C11.6497 12.1191 11.3318 12.2508 11.0003 12.2508Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)

export const MyCredentialsIcon = (props: IconProps) => (
  <Icon viewBox='0 0 22 22' {...props}>
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.17789 6.97933C9.17789 7.60433 9.17788 8.2101 9.375 8.7774C7.30288 11.2101 1.83173 17.638 1.32212 18.1284C1.22083 18.2192 1.13981 18.3304 1.08431 18.4547C1.02881 18.5789 1.00009 18.7134 1 18.8495C1 19.2582 1.25 19.6524 1.46154 19.8736C1.77885 20.2053 3.13462 21.4601 3.38462 21.2197C4.125 20.4986 4.27404 20.3062 4.57692 20.0082C5.03365 19.5611 4.52885 18.6476 4.6875 18.2774C4.84615 17.9072 5.01442 17.8351 5.28846 17.7774C5.5625 17.7197 6.04808 17.9168 6.42788 17.9216C6.82692 17.9264 7.04327 17.7582 7.34135 17.4793C7.58173 17.2582 7.75481 17.0514 7.75962 16.7293C7.76923 16.2966 7.14423 15.7245 7.61058 15.2678C8.07692 14.8111 8.75 15.5659 9.24519 15.5082C9.74038 15.4505 10.3413 14.763 10.4038 14.4697C10.4663 14.1764 9.84135 13.4216 9.9375 12.9937C9.97115 12.8495 10.2644 12.513 10.4856 12.4649C10.7067 12.4168 11.6875 12.7966 11.9087 12.7486C12.1779 12.6909 12.4904 12.4072 12.7452 12.2486C13.4904 12.5707 14.1683 12.7005 15.0385 12.7005C18.3317 12.7005 21 10.1332 21 6.96971C21 3.80625 18.3317 1.25 15.0385 1.25C11.7452 1.25 9.17789 3.81586 9.17789 6.97933V6.97933ZM17.9231 5.86538C17.9231 6.16966 17.8328 6.46711 17.6638 6.72011C17.4948 6.97311 17.2545 7.17029 16.9734 7.28674C16.6922 7.40318 16.3829 7.43365 16.0845 7.37428C15.786 7.31492 15.5119 7.1684 15.2968 6.95324C15.0816 6.73808 14.9351 6.46395 14.8757 6.16552C14.8164 5.86709 14.8468 5.55776 14.9633 5.27664C15.0797 4.99552 15.2769 4.75525 15.5299 4.5862C15.7829 4.41715 16.0803 4.32692 16.3846 4.32692C16.7926 4.32692 17.184 4.48901 17.4725 4.77753C17.761 5.06604 17.9231 5.45736 17.9231 5.86538Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinejoin='round'
      />
    </svg>
  </Icon>
)

export const HelpIcon = (props: IconProps) => (
  <Icon viewBox='0 0 20 20' {...props}>
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.5769 1H3.42308C2.781 1.00192 2.16574 1.27059 1.71172 1.74731C1.2577 2.22403 1.00183 2.87005 1 3.54423V12.2673C1.00183 12.9415 1.2577 13.5875 1.71172 14.0642C2.16574 14.541 2.781 14.8096 3.42308 14.8115H5.15385V18.4462L9.20904 14.896C9.27131 14.8414 9.34987 14.8115 9.43101 14.8115H16.5769C17.219 14.8096 17.8343 14.541 18.2883 14.0642C18.7423 13.5875 18.9982 12.9415 19 12.2673V3.54423C18.9982 2.87005 18.7423 2.22403 18.2883 1.74731C17.8343 1.27059 17.219 1.00192 16.5769 1V1Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinejoin='round'
      />
    </svg>
  </Icon>
)

export const PartnershipIcon = (props: IconProps) => (
  <Icon viewBox='0 0 22 22' {...props}>
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.1926 20.9999H3.80741C2.25772 20.9999 1 19.7429 1 18.1941V6.72381C1 5.17498 2.25772 3.91797 3.80741 3.91797H18.1926C19.7423 3.91797 21 5.17498 21 6.72381V18.1941C21 19.7541 19.7423 20.9999 18.1926 20.9999Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1 8.03711V9.03599C1 10.5848 2.25772 11.8418 3.80741 11.8418H18.1926C19.7423 11.8418 21 10.5848 21 9.03599V8.03711'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.98438 3.91807V3.24467C7.98438 2.0101 8.99504 1 10.2303 1H11.7575C12.9928 1 14.0035 2.0101 14.0035 3.24467V3.91807'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.59204 9.93384V13.3233'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.4075 9.93384V13.3233'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </Icon>
)

export const LanguageIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 25' {...props}>
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.0005 2.49982H9.33386V5.83315H10.6672V3.83315H20.0005C20.4005 3.83315 20.6672 4.09982 20.6672 4.49982V11.8332C20.6672 12.2332 20.4005 12.4998 20.0005 12.4998H11.3339V17.1665H7.80053L5.33386 19.0998V17.1665H3.33386C2.93386 17.1665 2.6672 16.8998 2.6672 16.4998V9.16648C2.6672 8.76648 2.93386 8.49982 3.33386 8.49982H12.0005V7.16648H3.33386C2.20053 7.16648 1.33386 8.03315 1.33386 9.16648V16.4998C1.33386 17.6332 2.20053 18.4998 3.33386 18.4998H4.00053V21.8998L8.20053 18.4998H12.6672V13.8332H20.0005C21.1339 13.8332 22.0005 12.9665 22.0005 11.8332V4.49982C22.0005 3.36648 21.1339 2.49982 20.0005 2.49982Z'
        fill='currentColor'
      />
      <path
        d='M4.13394 15.7665H5.73394L6.13394 14.6998H8.20061L8.60061 15.7665H10.2006L7.93394 9.83315H6.33394L4.13394 15.7665ZM7.13394 11.4998L7.80061 13.5665H6.46728L7.13394 11.4998Z'
        fill='currentColor'
      />
      <path
        d='M13.3339 11.8331C14.0673 11.8331 15.0673 11.6331 16.0006 11.1665C16.9339 11.6331 18.0006 11.8331 18.6673 11.8331V10.4998C18.6673 10.4998 18.0006 10.4998 17.2673 10.2332C18.0673 9.43315 18.6673 8.23315 18.6673 6.49982V5.83315H16.6673V4.49982H15.3339V5.83315H13.3339V7.16648H17.2673C17.1339 8.36648 16.6006 9.09982 16.0006 9.56648C15.6006 9.23315 15.2006 8.76648 14.9339 8.16648H13.5339C13.8006 9.03315 14.2006 9.69982 14.7339 10.2332C14.0673 10.4998 13.4673 10.4998 13.3339 10.4998V11.8331Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)

export const SearchIcon = (props: IconProps) => (
  <Icon viewBox='0 0 28 28' {...props}>
    <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_277_3780)'>
        <path
          d='M24.4997 24.5007L19.266 19.2577L24.4997 24.5007ZM22.1663 12.2507C22.1663 14.8807 21.1216 17.4031 19.2618 19.2628C17.4021 21.1225 14.8797 22.1673 12.2497 22.1673C9.61961 22.1673 7.09727 21.1225 5.23753 19.2628C3.3778 17.4031 2.33301 14.8807 2.33301 12.2507C2.33301 9.62059 3.3778 7.09824 5.23753 5.23851C7.09727 3.37877 9.61961 2.33398 12.2497 2.33398C14.8797 2.33398 17.4021 3.37877 19.2618 5.23851C21.1216 7.09824 22.1663 9.62059 22.1663 12.2507V12.2507Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_277_3780'>
          <rect width='28' height='28' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </Icon>
)

export const ChevronDown = (props: IconProps) => (
  <Icon viewBox='0 0 28 28' {...props}>
    <svg width='32' height='32' viewBox='0 0 17 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.71875 6.60938L8.5 11.3906L13.2812 6.60938'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </Icon>
)

export const RetractIcon = (props: IconProps) => (
  <Icon viewBox='0 0 17 24' {...props}>
    <svg width='17' height='24' viewBox='0 0 17 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2_58473)'>
        <path
          d='M10.0801 7.00003L5.93008 11.14L10.0801 15.28'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.93 11.1401H17'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4 20.46L2.46 20.46C1.36 20.46 0.460001 19.56 0.460001 18.46L0.46 5C0.46 3.9 1.36 3 2.46 3L4 3'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2_58473'>
          <rect width='24' height='17' fill='white' transform='matrix(0 -1 -1 0 17 24)' />
        </clipPath>
      </defs>
    </svg>
  </Icon>
)

export const ExpandIcon = (props: IconProps) => (
  <Icon viewBox='0 0 17 24' {...props}>
    <svg width='17' height='24' viewBox='0 0 17 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_591_3529)'>
        <path
          d='M6.91992 7.00027L11.0699 11.1403L6.91992 15.2803'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.07 11.1396H0'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13 20.46L14.54 20.46C15.64 20.46 16.54 19.56 16.54 18.46L16.54 5C16.54 3.9 15.64 3 14.54 3L13 3'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_591_3529'>
          <rect width='24' height='17' fill='white' transform='translate(0 24) rotate(-90)' />
        </clipPath>
      </defs>
    </svg>
  </Icon>
)

export const MenuPartnerLeft = (props: IconProps) => (
  <Icon viewBox='0 0 16 15' {...props}>
    <svg width='16' height='15' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 13H7C4.23858 13 2 10.7614 2 8V0H0V8C0 11.866 3.13401 15 7 15H16V13Z'
        fill='#E5E5E5'
      />
    </svg>
  </Icon>
)

export const SliderChevron = (props: IconProps) => (
  <Icon viewBox='0 0 17 31' {...props}>
    <svg width='17' height='31' viewBox='0 0 17 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.07605 2L15.1105 15.5L2.07605 29'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </Icon>
)

export const CertificateIcon = (props: IconProps) => (
  <Icon viewBox='0 0 32 31' {...props}>
    <svg width='32' height='31' viewBox='0 0 32 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 4.07215C0 3.04343 0.408657 2.05684 1.13607 1.32943C1.86348 0.602016 2.85007 0.193359 3.87879 0.193359H27.1515C28.1802 0.193359 29.1668 0.602016 29.8942 1.32943C30.6216 2.05684 31.0303 3.04343 31.0303 4.07215V10.1735C30.4458 9.65014 29.7934 9.20787 29.0909 8.85857V4.07215C29.0909 3.55779 28.8866 3.0645 28.5229 2.70079C28.1592 2.33708 27.6659 2.13275 27.1515 2.13275H3.87879C3.36443 2.13275 2.87114 2.33708 2.50743 2.70079C2.14372 3.0645 1.93939 3.55779 1.93939 4.07215V19.5873C1.93939 20.1017 2.14372 20.5949 2.50743 20.9587C2.87114 21.3224 3.36443 21.5267 3.87879 21.5267H17.9549C18.1023 21.7458 18.2594 21.9592 18.4242 22.1648V23.4661H3.87879C2.85007 23.4661 1.86348 23.0574 1.13607 22.33C0.408657 21.6026 0 20.616 0 19.5873V4.07215ZM32 16.6782C32 18.5284 31.2611 20.204 30.0606 21.4297V29.2843C30.0606 29.4643 30.0105 29.6409 29.9158 29.7941C29.8211 29.9473 29.6856 30.0711 29.5246 30.1516C29.3635 30.2321 29.1832 30.2662 29.0038 30.25C28.8245 30.2339 28.6532 30.1681 28.5091 30.06L25.7939 28.0237C25.6261 27.8978 25.4219 27.8297 25.2121 27.8297C25.0023 27.8297 24.7982 27.8978 24.6303 28.0237L21.9152 30.06C21.7711 30.1681 21.5998 30.2339 21.4204 30.25C21.2411 30.2662 21.0607 30.2321 20.8997 30.1516C20.7386 30.0711 20.6031 29.9473 20.5085 29.7941C20.4138 29.6409 20.3636 29.4643 20.3636 29.2843V21.4297C19.5845 20.6345 19.0129 19.6599 18.6992 18.5917C18.3856 17.5235 18.3394 16.3945 18.565 15.3043C18.7905 14.2141 19.2807 13.196 19.9924 12.3399C20.7041 11.4838 21.6154 10.8159 22.6461 10.395C23.6768 9.97417 24.7952 9.81328 25.9027 9.92654C27.0102 10.0398 28.0729 10.4237 28.997 11.0445C29.9212 11.6653 30.6785 12.5038 31.2022 13.4863C31.7258 14.4687 31.9998 15.5649 32 16.6782ZM25.2121 23.4661C24.1707 23.4661 23.1855 23.2334 22.303 22.8125V26.86L24.7137 25.4132C24.8643 25.323 25.0366 25.2753 25.2121 25.2753C25.3877 25.2753 25.5599 25.323 25.7105 25.4132L28.1212 26.86V22.8125C27.2122 23.2441 26.2184 23.4674 25.2121 23.4661ZM25.2121 21.5267C26.498 21.5267 27.7312 21.0159 28.6405 20.1066C29.5498 19.1973 30.0606 17.9641 30.0606 16.6782C30.0606 15.3923 29.5498 14.1591 28.6405 13.2498C27.7312 12.3405 26.498 11.8297 25.2121 11.8297C23.9262 11.8297 22.693 12.3405 21.7837 13.2498C20.8745 14.1591 20.3636 15.3923 20.3636 16.6782C20.3636 17.9641 20.8745 19.1973 21.7837 20.1066C22.693 21.0159 23.9262 21.5267 25.2121 21.5267ZM5.81818 6.98124C5.81818 6.72406 5.92035 6.47741 6.1022 6.29556C6.28405 6.11371 6.5307 6.01154 6.78788 6.01154H24.2424C24.4996 6.01154 24.7463 6.11371 24.9281 6.29556C25.11 6.47741 25.2121 6.72406 25.2121 6.98124C25.2121 7.23842 25.11 7.48506 24.9281 7.66692C24.7463 7.84877 24.4996 7.95093 24.2424 7.95093H6.78788C6.5307 7.95093 6.28405 7.84877 6.1022 7.66692C5.92035 7.48506 5.81818 7.23842 5.81818 6.98124ZM6.78788 15.7085C6.5307 15.7085 6.28405 15.8107 6.1022 15.9925C5.92035 16.1744 5.81818 16.421 5.81818 16.6782C5.81818 16.9354 5.92035 17.182 6.1022 17.3639C6.28405 17.5457 6.5307 17.6479 6.78788 17.6479H14.5455C14.8026 17.6479 15.0493 17.5457 15.2311 17.3639C15.413 17.182 15.5152 16.9354 15.5152 16.6782C15.5152 16.421 15.413 16.1744 15.2311 15.9925C15.0493 15.8107 14.8026 15.7085 14.5455 15.7085H6.78788Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)

export const CheckIcon = (props: IconProps) => (
  <Icon viewBox='0 0 26 19' {...props}>
    <svg width='26' height='19' viewBox='0 0 26 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <line x1='1.4735' y1='6.05537' x2='11.0989' y2='16.4829' stroke='currentColor' strokeWidth='4.01059' />
      <line x1='23.6728' y1='1.41796' x2='8.43258' y2='16.6582' stroke='currentColor' strokeWidth='4.01059' />
    </svg>
  </Icon>
)

export const AkarCircleCheckIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 24' {...props}>
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 12.5L11 15.5L16 9.5'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  </Icon>
)

export const Icons8CircleCloseIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 24' {...props}>
    <svg width='27' height='26' viewBox='0 0 27 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.5 2.4375C7.676 2.4375 2.9375 7.176 2.9375 13C2.9375 18.824 7.676 23.5625 13.5 23.5625C19.324 23.5625 24.0625 18.824 24.0625 13C24.0625 7.176 19.324 2.4375 13.5 2.4375ZM13.5 4.0625C18.4457 4.0625 22.4375 8.05431 22.4375 13C22.4375 17.9457 18.4457 21.9375 13.5 21.9375C8.55431 21.9375 4.5625 17.9457 4.5625 13C4.5625 8.05431 8.55431 4.0625 13.5 4.0625ZM10.4288 8.75875L9.25875 9.92875L12.3333 13L9.26037 16.0713L10.4304 17.2412L13.5 14.1676L16.5713 17.2388L17.7412 16.0713L14.6676 13L17.7388 9.92875L16.5713 8.75875L13.5 11.8333L10.4288 8.76037V8.75875Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)

export const MedalIcon = (props: IconProps) => (
  <Icon viewBox='0 0 25 33' {...props}>
    <svg width='25' height='33' viewBox='0 0 25 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.90735e-06 12.0425C-0.0019474 10.0148 0.52327 8.01949 1.52686 6.24196C2.53044 4.46444 3.97984 2.96235 5.74041 1.87523C7.50098 0.788122 9.5156 0.151255 11.5971 0.0237952C13.6786 -0.103664 15.7595 0.28242 17.6465 1.14618C19.5334 2.00994 21.1652 3.32336 22.3903 4.96442C23.6153 6.60547 24.3939 8.52094 24.6536 10.5329C24.9134 12.5448 24.6459 14.5879 23.876 16.4724C23.1061 18.3569 21.8588 20.0217 20.25 21.312V31.73C20.2511 31.9166 20.2025 32.1004 20.1089 32.2633C20.0152 32.4263 19.8797 32.5628 19.7156 32.6597C19.5528 32.7592 19.3665 32.8164 19.1745 32.826C18.9825 32.8356 18.7912 32.7971 18.6188 32.7144L12.375 29.6655L6.13125 32.7144C5.97159 32.783 5.79952 32.8201 5.625 32.8237C5.32663 32.8237 5.04048 32.7085 4.82951 32.5034C4.61853 32.2983 4.5 32.0201 4.5 31.73V21.312C3.09262 20.1857 1.95922 18.7704 1.18117 17.1677C0.403128 15.565 -0.000249863 13.8147 1.90735e-06 12.0425ZM22.5 12.0425C22.5 10.0956 21.9062 8.1924 20.7936 6.5736C19.6811 4.9548 18.0998 3.6931 16.2497 2.94805C14.3996 2.203 12.3638 2.00807 10.3997 2.38789C8.43565 2.76771 6.63155 3.70524 5.21555 5.08191C3.79954 6.45858 2.83522 8.21257 2.44455 10.1221C2.05387 12.0316 2.25438 14.0108 3.02072 15.8095C3.78706 17.6082 5.08481 19.1456 6.74986 20.2273C8.4149 21.3089 10.3725 21.8862 12.375 21.8862C15.0592 21.8826 17.6323 20.8444 19.5303 18.9991C21.4283 17.1538 22.4963 14.6521 22.5 12.0425ZM6.75 29.9663L11.8688 27.4644C12.0267 27.3905 12.1997 27.3521 12.375 27.3521C12.5503 27.3521 12.7233 27.3905 12.8813 27.4644L18 29.9663V22.7612C16.2579 23.6244 14.3303 24.0743 12.375 24.0743C10.4197 24.0743 8.49215 23.6244 6.75 22.7612V29.9663ZM12.375 19.6987C10.8175 19.6987 9.29492 19.2497 7.99989 18.4084C6.70485 17.5672 5.69549 16.3714 5.09945 14.9724C4.50341 13.5734 4.34746 12.034 4.65132 10.5488C4.95518 9.06367 5.7052 7.69945 6.80654 6.62871C7.90788 5.55796 9.31106 4.82877 10.8387 4.53336C12.3663 4.23794 13.9497 4.38956 15.3886 4.96904C16.8276 5.54852 18.0575 6.52985 18.9228 7.78891C19.7881 9.04797 20.25 10.5282 20.25 12.0425C20.25 14.0731 19.4203 16.0205 17.9435 17.4563C16.4666 18.8921 14.4636 19.6987 12.375 19.6987ZM12.375 6.57374C11.2625 6.57374 10.1749 6.89448 9.24992 7.49539C8.32489 8.09631 7.60392 8.95041 7.17818 9.94969C6.75244 10.949 6.64104 12.0486 6.85808 13.1094C7.07512 14.1702 7.61086 15.1447 8.39753 15.9095C9.1842 16.6743 10.1865 17.1952 11.2776 17.4062C12.3688 17.6172 13.4998 17.5089 14.5276 17.095C15.5554 16.681 16.4339 15.9801 17.052 15.0808C17.6701 14.1814 18 13.1241 18 12.0425C17.9963 10.5932 17.4025 9.2043 16.3484 8.17949C15.2943 7.15468 13.8657 6.57735 12.375 6.57374Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)

export const HeartIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 24' {...props}>
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.6 3.59998C15.53 3.59998 13.74 4.81998 12.9 6.56998C12.06 4.81998 10.28 3.59998 8.2 3.59998C5.33 3.59998 3 5.92998 3 8.79998C3 12.91 8.98 18.18 11.64 20.32C12.38 20.91 13.42 20.91 14.15 20.32C16.82 18.17 22.79 12.9 22.79 8.79998C22.8 5.92998 20.47 3.59998 17.6 3.59998Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M18 6C18.6667 6 20 6.4 20 8' stroke='currentColor' strokeLinecap='round' />
    </svg>
  </Icon>
)

export const EvaluateIconSvg = (props: IconProps) => (
  <Icon viewBox='0 0 29 28' {...props}>
    <svg width='29' height='28' viewBox='0 0 29 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.3244 1.97249L19.0917 7.4694C19.4818 8.03859 20.0561 8.45591 20.718 8.65102L27.11 10.5353C27.784 10.7339 28.0483 11.5474 27.6198 12.1043L23.5561 17.3858C23.1353 17.9327 22.9159 18.6079 22.9349 19.2977L23.1181 25.9591C23.1374 26.6615 22.4455 27.1642 21.7834 26.9288L15.5047 24.6961C14.8545 24.4649 14.1445 24.4649 13.4944 24.6961L7.21558 26.9288C6.55357 27.1642 5.86159 26.6615 5.88091 25.9591L6.06412 19.2977C6.08309 18.6079 5.8637 17.9327 5.44291 17.3858L1.37919 12.1043C0.950727 11.5474 1.21504 10.7339 1.88899 10.5353L8.28101 8.65102C8.94289 8.45591 9.51727 8.03859 9.90737 7.4694L13.6746 1.9725C14.0718 1.39292 14.9272 1.39292 15.3244 1.97249Z'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  </Icon>
)

export const EvaluateIconFilledSvg = (props: IconProps) => (
  <Icon viewBox='0 0 29 28' {...props}>
    <svg width='24' height='22' viewBox='0 0 24 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.3501 1.34197C11.6631 0.885332 12.3369 0.885332 12.6499 1.34196L15.6181 5.67286C15.9254 6.12132 16.3779 6.45011 16.8994 6.60383L21.9356 8.0884C22.4666 8.24492 22.6748 8.88584 22.3372 9.32458L19.1355 13.4858C18.804 13.9167 18.6311 14.4487 18.6461 14.9921L18.7904 20.2405C18.8056 20.7939 18.2604 21.19 17.7389 21.0045L12.7919 19.2454C12.2797 19.0632 11.7203 19.0632 11.2081 19.2454L6.26114 21.0045C5.73956 21.19 5.19437 20.7939 5.20959 20.2405L5.35393 14.9921C5.36888 14.4487 5.19602 13.9167 4.86449 13.4858L1.66278 9.32458C1.3252 8.88583 1.53345 8.24492 2.06444 8.0884L7.10057 6.60383C7.62205 6.45011 8.0746 6.12132 8.38195 5.67286L11.3501 1.34197Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='1.57576'
      />
    </svg>
  </Icon>
)

export const FeedbackIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 27' {...props}>
    <svg width='24' height='27' viewBox='0 0 24 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.46625e-05 2.70514L2.44059e-05 24.2216C2.43881e-05 25.7137 1.21391 26.9272 2.70562 26.9272L15.4562 26.9272C16.9483 26.9272 18.1618 25.7133 18.1618 24.2216L18.162 23.9082L20.6973 23.9082C21.7851 23.9082 22.762 23.2623 23.1854 22.2634C23.3296 21.9258 23.4029 21.5686 23.4029 21.2026C23.4029 20.5014 23.1342 19.8353 22.6466 19.3268L18.1618 14.6654L18.1618 2.70579C18.1618 1.21369 16.9479 0.000192844 15.4562 0.000192827L2.70559 3.22639e-08C1.21389 1.44755e-08 3.06633e-07 1.21349 2.8884e-07 2.70559L2.46625e-05 2.70514ZM16.5793 24.2216C16.5793 24.8409 16.0753 25.3449 15.4559 25.3449L2.70537 25.3449C2.08604 25.3449 1.58202 24.8409 1.58202 24.2216L1.58202 2.70564C1.58202 2.08631 2.08604 1.58229 2.70537 1.58229L15.4559 1.58229C16.0753 1.58229 16.5793 2.08631 16.5793 2.70564L16.5793 15.3022L21.5062 20.4226C21.7086 20.6341 21.82 20.9106 21.82 21.2019C21.82 21.3515 21.7889 21.5036 21.7299 21.6413C21.5534 22.0565 21.1483 22.3253 20.6967 22.3253L16.5791 22.3253L16.5793 24.2216Z'
        fill='currentColor'
      />
      <path
        d='M6.64748 14.0248L6.64748 21.019C6.64748 21.4419 6.30464 21.7848 5.88169 21.7848C5.45875 21.7848 5.11591 21.4419 5.11591 21.019L5.11591 14.0248C5.11591 13.6019 5.45875 13.259 5.88169 13.259C6.30464 13.259 6.64748 13.6019 6.64748 14.0248Z'
        fill='currentColor'
      />
      <path
        d='M9.91451 9.99153L9.91451 21.0185C9.91451 21.4414 9.57167 21.7842 9.14872 21.7842C8.72578 21.7842 8.38293 21.4414 8.38293 21.0185L8.38293 9.99153C8.38293 9.56858 8.72578 9.22574 9.14872 9.22574C9.57186 9.22574 9.91451 9.56839 9.91451 9.99153Z'
        fill='currentColor'
      />
      <path
        d='M13.182 5.90726L13.182 21.0185C13.182 21.4414 12.8392 21.7842 12.4162 21.7842C11.9933 21.7842 11.6505 21.4414 11.6505 21.0185L11.6505 5.90726C11.6505 5.48432 11.9933 5.14147 12.4162 5.14147C12.8392 5.14147 13.182 5.48432 13.182 5.90726Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)

export const FeedbackHorizontalIcon = (props: IconProps) => (
  <Box transform='rotate(90deg)'>
    <Icon viewBox='0 0 24 27' {...props}>
      <svg width='24' height='27' viewBox='0 0 24 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M2.46625e-05 2.70514L2.44059e-05 24.2216C2.43881e-05 25.7137 1.21391 26.9272 2.70562 26.9272L15.4562 26.9272C16.9483 26.9272 18.1618 25.7133 18.1618 24.2216L18.162 23.9082L20.6973 23.9082C21.7851 23.9082 22.762 23.2623 23.1854 22.2634C23.3296 21.9258 23.4029 21.5686 23.4029 21.2026C23.4029 20.5014 23.1342 19.8353 22.6466 19.3268L18.1618 14.6654L18.1618 2.70579C18.1618 1.21369 16.9479 0.000192844 15.4562 0.000192827L2.70559 3.22639e-08C1.21389 1.44755e-08 3.06633e-07 1.21349 2.8884e-07 2.70559L2.46625e-05 2.70514ZM16.5793 24.2216C16.5793 24.8409 16.0753 25.3449 15.4559 25.3449L2.70537 25.3449C2.08604 25.3449 1.58202 24.8409 1.58202 24.2216L1.58202 2.70564C1.58202 2.08631 2.08604 1.58229 2.70537 1.58229L15.4559 1.58229C16.0753 1.58229 16.5793 2.08631 16.5793 2.70564L16.5793 15.3022L21.5062 20.4226C21.7086 20.6341 21.82 20.9106 21.82 21.2019C21.82 21.3515 21.7889 21.5036 21.7299 21.6413C21.5534 22.0565 21.1483 22.3253 20.6967 22.3253L16.5791 22.3253L16.5793 24.2216Z'
          fill='currentColor'
        />
        <path
          d='M6.64748 14.0248L6.64748 21.019C6.64748 21.4419 6.30464 21.7848 5.88169 21.7848C5.45875 21.7848 5.11591 21.4419 5.11591 21.019L5.11591 14.0248C5.11591 13.6019 5.45875 13.259 5.88169 13.259C6.30464 13.259 6.64748 13.6019 6.64748 14.0248Z'
          fill='currentColor'
        />
        <path
          d='M9.91451 9.99153L9.91451 21.0185C9.91451 21.4414 9.57167 21.7842 9.14872 21.7842C8.72578 21.7842 8.38293 21.4414 8.38293 21.0185L8.38293 9.99153C8.38293 9.56858 8.72578 9.22574 9.14872 9.22574C9.57186 9.22574 9.91451 9.56839 9.91451 9.99153Z'
          fill='currentColor'
        />
        <path
          d='M13.182 5.90726L13.182 21.0185C13.182 21.4414 12.8392 21.7842 12.4162 21.7842C11.9933 21.7842 11.6505 21.4414 11.6505 21.0185L11.6505 5.90726C11.6505 5.48432 11.9933 5.14147 12.4162 5.14147C12.8392 5.14147 13.182 5.48432 13.182 5.90726Z'
          fill='currentColor'
        />
      </svg>
    </Icon>
  </Box>
)

export const AnalyticsIcon = (props: IconProps) => (
  <Icon viewBox='0 0 20 22' {...props}>
    <svg width='20' height='22' viewBox='0 0 20 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.875 13.979H1.375C1.16789 13.979 1 14.1404 1 14.3396V20.83C1 21.0291 1.16789 21.1905 1.375 21.1905H2.875C3.08211 21.1905 3.25 21.0291 3.25 20.83V14.3396C3.25 14.1404 3.08211 13.979 2.875 13.979Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.375 9.65356H11.875C11.6679 9.65356 11.5 9.815 11.5 10.0141V20.8314C11.5 21.0306 11.6679 21.192 11.875 21.192H13.375C13.5821 21.192 13.75 21.0306 13.75 20.8314V10.0141C13.75 9.815 13.5821 9.65356 13.375 9.65356Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.625 4.60425H17.125C16.9179 4.60425 16.75 4.76568 16.75 4.96482V20.8302C16.75 21.0293 16.9179 21.1908 17.125 21.1908H18.625C18.8321 21.1908 19 21.0293 19 20.8302V4.96482C19 4.76568 18.8321 4.60425 18.625 4.60425Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.125 1H6.625C6.41789 1 6.25 1.16144 6.25 1.36058V20.8317C6.25 21.0309 6.41789 21.1923 6.625 21.1923H8.125C8.33211 21.1923 8.5 21.0309 8.5 20.8317V1.36058C8.5 1.16144 8.33211 1 8.125 1Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </Icon>
)

export const ChangeIcon = (props: IconProps) => (
  <Icon viewBox='0 0 22 18' {...props}>
    <svg width='22' height='18' viewBox='0 0 22 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7795 11.0203L18.7792 11.02C18.5439 10.7847 18.1317 10.7847 17.8964 11.02C17.6611 11.2552 17.6611 11.6675 17.8964 11.9028L19.3393 13.3457L15.8083 13.3456C15.1171 13.3456 14.4696 13.0525 14.0313 12.5308L14.0313 12.5308L14.0303 12.5296L10.9687 8.99703L14.0088 5.46463L14.0088 5.46463L14.0095 5.46372C14.4475 4.94238 15.1166 4.64897 15.7865 4.64897H19.3175L17.8745 6.09192C17.6392 6.32719 17.6392 6.73944 17.8745 6.9747C18.0043 7.10446 18.1615 7.1567 18.3159 7.1567C18.4704 7.1567 18.6275 7.10446 18.7573 6.9747L21.2649 4.46712C21.5001 4.23193 21.5001 3.81987 21.2651 3.58456C21.265 3.58449 21.2649 3.58442 21.2649 3.58434L18.7795 1.07677L18.7792 1.07645C18.5439 0.841183 18.1317 0.841182 17.8964 1.07645C17.6611 1.31172 17.6611 1.72396 17.8964 1.95923L19.3393 3.40218H15.8083C14.7544 3.40218 13.7672 3.85087 13.0722 4.65801L10.1603 8.03761L7.22717 4.65801C7.22714 4.65798 7.22711 4.65795 7.22708 4.65791C6.53209 3.85084 5.54494 3.40218 4.49109 3.40218H1.17674C0.837984 3.40218 0.553359 3.68683 0.553359 4.02556C0.553359 4.36429 0.838002 4.64893 1.17674 4.64893H4.49125C5.1824 4.64893 5.82995 4.94198 6.26824 5.46368L6.26824 5.46369L6.26924 5.46485L9.33066 8.99745L6.29058 12.5299L6.28982 12.5308C5.85182 13.0521 5.18273 13.3455 4.51282 13.3455H1.1767C0.837945 13.3455 0.55332 13.6302 0.55332 13.9689C0.55332 14.3076 0.837963 14.5923 1.1767 14.5923H4.49121C5.5451 14.5923 6.53229 14.1436 7.22728 13.3364L10.1389 9.95731L13.0504 13.3364C13.7454 14.1436 14.7326 14.5923 15.7865 14.5923H19.3174L17.8745 16.0352C17.6392 16.2705 17.6392 16.6827 17.8745 16.918C18.0042 17.0478 18.1614 17.1 18.3159 17.1C18.4703 17.1 18.6275 17.0478 18.7573 16.918L21.2648 14.4104C21.3946 14.2807 21.4468 14.1235 21.4468 13.969C21.4468 13.8116 21.3709 13.6337 21.2651 13.5279C21.265 13.5278 21.2649 13.5277 21.2648 13.5276L18.7795 11.0203Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.2'
      />
    </svg>
  </Icon>
)

export const AdminUniversityIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 23' {...props}>
    <svg width='24' height='23' viewBox='0 0 24 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.6936 0.514291L11.6938 0.514708L11.7017 0.508727C11.8539 0.393437 12.0951 0.386366 12.3065 0.514367C12.3066 0.514424 12.3067 0.514482 12.3068 0.514539L23.0607 7.13181C23.2266 7.25923 23.355 7.47261 23.4 7.6875V8.64379C23.4 8.96738 23.1182 9.22031 22.7827 9.22031H1.2173C1.02499 9.22031 0.871441 9.15591 0.766575 9.05498C0.661803 8.95415 0.6 8.81157 0.6 8.64379V7.67742C0.6 7.47461 0.72182 7.26206 0.891299 7.13187L11.6936 0.514291ZM4.08166 7.25401L3.78121 7.43915H4.13412H19.818H20.1709L19.8705 7.25401L12.0285 2.42172L11.9761 2.38939L11.9236 2.42172L4.08166 7.25401Z'
        fill='white'
        stroke='#313E4C'
        strokeWidth='0.2'
      />
      <path
        d='M2.16525 20.7406H21.8347C22.4031 20.7406 22.9 21.152 22.9 21.6406C22.9 22.1316 22.447 22.5406 21.8347 22.5406H2.16525C1.55304 22.5406 1.1 22.1316 1.1 21.6406C1.1 21.1497 1.55304 20.7406 2.16525 20.7406Z'
        fill='white'
        stroke='#313E4C'
        strokeWidth='0.2'
      />
      <path
        d='M2.1 19.9V10.1L21.9 10.1V19.9H19.8551V12.8708C19.8551 12.3629 19.6383 11.909 19.3187 11.5593L19.3189 11.5591L19.3133 11.5538C18.9409 11.2046 18.4072 10.9525 17.8674 10.9525C16.7469 10.9525 15.8287 11.8047 15.8287 12.8707V19.8998H14.0389L14.0387 12.8707C14.0387 11.8047 13.1205 10.9525 12 10.9525C10.8795 10.9525 9.96128 11.8047 9.96128 12.8707V19.8998H8.17149V12.8707C8.17149 11.8047 7.25327 10.9525 6.13276 10.9525C5.28158 10.9525 4.52899 11.4499 4.25587 12.1594C4.14674 12.367 4.09406 12.6206 4.09406 12.8707V19.8998L2.1 19.9Z'
        fill='white'
        stroke='#313E4C'
        strokeWidth='0.2'
      />
    </svg>
  </Icon>
)
export const BurguerIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 24' {...props}>
    <svg width='32' height='20' viewBox='0 0 32 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='4' fill='#313E4C' />
      <rect y='8' width='32' height='4' fill='#313E4C' />
      <rect y='16' width='32' height='4' fill='#313E4C' />
    </svg>
  </Icon>
)

export const ExtensionIcon = (props: IconProps) => (
  <Icon viewBox='0 0 24 24' {...props}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      className='w-6 h-6'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 01-.61-.58v0z'
      />
    </svg>
  </Icon>
)

export const CorporateUniversityIcon = (props: IconProps) => (
  <Icon iewBox='0 0 24 24' {...props}>
    <svg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.1936 0.193978L11.1938 0.194396L11.2017 0.188414C11.3539 0.0731241 11.5951 0.0660537 11.8065 0.194054C11.8066 0.194112 11.8067 0.194169 11.8068 0.194227L22.5607 6.8115C22.7266 6.93892 22.855 7.1523 22.9 7.36719V8.32348C22.9 8.64706 22.6182 8.9 22.2827 8.9H0.717296C0.524985 8.9 0.371441 8.8356 0.266575 8.73467C0.161803 8.63383 0.1 8.49125 0.1 8.32348V7.35711C0.1 7.1543 0.22182 6.94174 0.391299 6.81156L11.1936 0.193978ZM3.58166 6.9337L3.28121 7.11884H3.63412H19.318H19.6709L19.3705 6.9337L11.5285 2.10141L11.4761 2.06908L11.4236 2.10141L3.58166 6.9337Z'
        fill='white'
        stroke='#313E4C'
        stroke-width='0.2'
      />
      <path
        d='M1.66525 20.4203H21.3347C21.9031 20.4203 22.4 20.8317 22.4 21.3203C22.4 21.8113 21.947 22.2203 21.3347 22.2203H1.66525C1.05304 22.2203 0.6 21.8113 0.6 21.3203C0.6 20.8293 1.05304 20.4203 1.66525 20.4203Z'
        fill='white'
        stroke='#313E4C'
        stroke-width='0.2'
      />
      <path
        d='M1.6 19.5797V9.77973L21.4 9.77969V19.5796H19.3551V12.5505C19.3551 12.0426 19.1383 11.5887 18.8187 11.239L18.8189 11.2388L18.8133 11.2335C18.4409 10.8843 17.9072 10.6322 17.3674 10.6322C16.2469 10.6322 15.3287 11.4844 15.3287 12.5504V19.5795H13.5389L13.5387 12.5504C13.5387 11.4844 12.6205 10.6322 11.5 10.6322C10.3795 10.6322 9.46128 11.4844 9.46128 12.5504V19.5795H7.67149V12.5504C7.67149 11.4844 6.75327 10.6322 5.63276 10.6322C4.78158 10.6322 4.02899 11.1296 3.75587 11.8391C3.64674 12.0467 3.59406 12.3003 3.59406 12.5504V19.5795L1.6 19.5797Z'
        fill='white'
        stroke='#313E4C'
        stroke-width='0.2'
      />
    </svg>
  </Icon>
)

export const EditContent = (props: IconProps) => (
  <Icon iewBox='0 0 24 24' {...props}>
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.5597 2.49586C21.4912 2.4206 21.4081 2.36001 21.3156 2.31775C21.223 2.27548 21.1228 2.25243 21.0211 2.24997C20.9193 2.24752 20.8182 2.26572 20.7237 2.30347C20.6292 2.34122 20.5433 2.39774 20.4713 2.46961L19.8914 3.04664C19.8211 3.11696 19.7817 3.21231 19.7817 3.31172C19.7817 3.41114 19.8211 3.50648 19.8914 3.5768L20.423 4.10743C20.4578 4.14243 20.4992 4.17021 20.5448 4.18917C20.5905 4.20812 20.6394 4.21788 20.6887 4.21788C20.7381 4.21788 20.787 4.20812 20.8327 4.18917C20.8783 4.17021 20.9197 4.14243 20.9545 4.10743L21.5198 3.54493C21.8058 3.25946 21.8325 2.79446 21.5597 2.49586Z'
        fill='#767F89'
      />
      <path
        d='M18.7191 4.21852L10.2572 12.6654C10.2059 12.7165 10.1686 12.7799 10.1489 12.8496L9.7575 14.0154C9.74812 14.047 9.74746 14.0806 9.75558 14.1126C9.7637 14.1446 9.78029 14.1738 9.80362 14.1971C9.82695 14.2204 9.85615 14.237 9.88813 14.2451C9.9201 14.2532 9.95368 14.2526 9.98531 14.2432L11.1502 13.8518C11.2198 13.8321 11.2833 13.7948 11.3344 13.7435L19.7812 5.28071C19.8594 5.20172 19.9032 5.0951 19.9032 4.98399C19.9032 4.87288 19.8594 4.76625 19.7812 4.68727L19.3148 4.21852C19.2358 4.13966 19.1286 4.09537 19.017 4.09537C18.9053 4.09537 18.7981 4.13966 18.7191 4.21852Z'
        fill='#767F89'
      />
      <path
        d='M18.1097 9.07758L12.3961 14.8024C12.1753 15.0238 11.9039 15.1881 11.6053 15.281L10.3912 15.6874C10.1031 15.7688 9.79851 15.7719 9.5088 15.6963C9.2191 15.6208 8.95477 15.4693 8.74307 15.2576C8.53136 15.0459 8.37994 14.7816 8.30439 14.4919C8.22885 14.2022 8.23191 13.8976 8.31328 13.6095L8.71969 12.3954C8.81238 12.0969 8.97632 11.8255 9.19734 11.6046L14.9222 5.89008C14.9747 5.83767 15.0104 5.77086 15.0249 5.69812C15.0394 5.62539 15.032 5.54998 15.0037 5.48144C14.9753 5.4129 14.9273 5.35431 14.8657 5.31307C14.804 5.27183 14.7315 5.2498 14.6573 5.24977H4.875C4.17881 5.24977 3.51113 5.52633 3.01884 6.01862C2.52656 6.5109 2.25 7.17858 2.25 7.87477V19.1248C2.25 19.821 2.52656 20.4886 3.01884 20.9809C3.51113 21.4732 4.17881 21.7498 4.875 21.7498H16.125C16.8212 21.7498 17.4889 21.4732 17.9812 20.9809C18.4734 20.4886 18.75 19.821 18.75 19.1248V9.34243C18.75 9.26826 18.7279 9.19576 18.6867 9.13411C18.6455 9.07246 18.5869 9.02442 18.5183 8.99607C18.4498 8.96772 18.3744 8.96034 18.3016 8.97484C18.2289 8.98935 18.1621 9.02511 18.1097 9.07758Z'
        fill='#767F89'
      />
    </svg>
  </Icon>
)

export const DeleteContent = (props: IconProps) => (
  <Icon iewBox='0 0 24 24' {...props}>
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 2.25C6.62391 2.25 2.25 6.62391 2.25 12C2.25 17.3761 6.62391 21.75 12 21.75C17.3761 21.75 21.75 17.3761 21.75 12C21.75 6.62391 17.3761 2.25 12 2.25ZM15.5302 14.4698C15.6027 14.5388 15.6608 14.6216 15.7008 14.7133C15.7409 14.805 15.7622 14.9039 15.7635 15.004C15.7648 15.1041 15.746 15.2034 15.7083 15.2961C15.6706 15.3889 15.6147 15.4731 15.5439 15.5439C15.4731 15.6147 15.3889 15.6706 15.2961 15.7083C15.2034 15.746 15.1041 15.7648 15.004 15.7635C14.9039 15.7622 14.805 15.7409 14.7133 15.7008C14.6216 15.6608 14.5388 15.6027 14.4698 15.5302L12 13.0608L9.53016 15.5302C9.38836 15.6649 9.19955 15.7389 9.00398 15.7364C8.8084 15.7339 8.62155 15.6551 8.48325 15.5168C8.34495 15.3785 8.26614 15.1916 8.26364 14.996C8.26114 14.8005 8.33513 14.6116 8.46984 14.4698L10.9392 12L8.46984 9.53016C8.33513 9.38836 8.26114 9.19955 8.26364 9.00398C8.26614 8.8084 8.34495 8.62155 8.48325 8.48325C8.62155 8.34495 8.8084 8.26614 9.00398 8.26364C9.19955 8.26114 9.38836 8.33513 9.53016 8.46984L12 10.9392L14.4698 8.46984C14.6116 8.33513 14.8005 8.26114 14.996 8.26364C15.1916 8.26614 15.3785 8.34495 15.5168 8.48325C15.6551 8.62155 15.7339 8.8084 15.7364 9.00398C15.7389 9.19955 15.6649 9.38836 15.5302 9.53016L13.0608 12L15.5302 14.4698Z'
        fill='#767F89'
      />
    </svg>
  </Icon>
)

export const DownloadModelIcon = (props: IconProps) => (
  <Icon iewBox='0 0 16 18' {...props}>
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='18' viewBox='0 0 16 18' fill='none'>
      <path
        d='M11.0371 5.86548H12.71C13.1536 5.86548 13.5791 6.03061 13.8928 6.32453C14.2066 6.61846 14.3828 7.01711 14.3828 7.43279V15.5828C14.3828 15.9985 14.2066 16.3971 13.8928 16.691C13.5791 16.985 13.1536 17.1501 12.71 17.1501H2.67285C2.22918 17.1501 1.80369 16.985 1.48997 16.691C1.17625 16.3971 1 15.9985 1 15.5828V7.43279C1 7.01711 1.17625 6.61846 1.48997 6.32453C1.80369 6.03061 2.22918 5.86548 2.67285 5.86548H4.3457'
        stroke='white'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M4.34644 9.62671L7.69214 12.7613L11.0378 9.62671'
        stroke='white'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M7.69287 0.849854V12.1344'
        stroke='white'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  </Icon>
)
